var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionGiftColoredRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7V10H4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V10H21V7H3Z",
    fill: "url(#paint0_linear_2369_2233)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7V10H4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V10H21V7H3Z",
    fill: "url(#paint1_linear_2369_2233)",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7V10H4H20H21V7H3Z",
    fill: "#7029EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5C6 3.34315 7.34315 2 9 2C10.5048 2 11.7509 3.10798 11.9669 4.55266L12 4.58579L12.0331 4.55266C12.2491 3.10798 13.4952 2 15 2C16.6569 2 18 3.34315 18 5C18 6.52496 16.8622 7.78417 15.3892 7.97499L17.7071 10.2929L16.2929 11.7071L13 8.41421V22H11V8.41421L7.70711 11.7071L6.29289 10.2929L8.6108 7.97499C7.13782 7.78417 6 6.52496 6 5ZM9 4C9.55228 4 10 4.44772 10 5C10 5.55228 9.55228 6 9 6C8.44772 6 8 5.55228 8 5C8 4.44772 8.44772 4 9 4ZM15 4C15.5523 4 16 4.44772 16 5C16 5.55228 15.5523 6 15 6C14.4477 6 14 5.55228 14 5C14 4.44772 14.4477 4 15 4Z",
    fill: "url(#paint2_linear_2369_2233)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6C9.55228 6 10 5.55228 10 5C10 4.44772 9.55228 4 9 4C8.44772 4 8 4.44772 8 5C8 5.55228 8.44772 6 9 6Z",
    fill: "#A1111F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6C15.5523 6 16 5.55228 16 5C16 4.44772 15.5523 4 15 4C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6Z",
    fill: "#A1111F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2C10.6569 2 12 3.34315 12 5C12 6.65685 10.6569 8 9 8C7.34315 8 6 6.65685 6 5C6 3.34315 7.34315 2 9 2ZM9 4C8.44772 4 8 4.44772 8 5C8 5.55228 8.44772 6 9 6C9.55228 6 10 5.55228 10 5C10 4.44772 9.55228 4 9 4Z",
    fill: "url(#paint3_linear_2369_2233)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2C16.6569 2 18 3.34315 18 5C18 6.65685 16.6569 8 15 8C13.3431 8 12 6.65685 12 5C12 3.34315 13.3431 2 15 2ZM15 4C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6C15.5523 6 16 5.55228 16 5C16 4.44772 15.5523 4 15 4Z",
    fill: "url(#paint4_linear_2369_2233)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.707 5.70703L13.4141 6L17.707 10.293L16.293 11.707L12 7.41406L7.70703 11.707L6.29297 10.293L10.5859 6L10.293 5.70703L11.707 4.29297L12 4.58594L12.293 4.29297L13.707 5.70703Z",
    fill: "url(#paint5_linear_2369_2233)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2369_2233",
    x1: 12,
    y1: 7,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4911AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5714CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2369_2233",
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2369_2233",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB4550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928125,
    stopColor: "#E82B3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE5E6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2369_2233",
    x1: 9,
    y1: 8,
    x2: 9,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E82C3D",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F986"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2369_2233",
    x1: 15,
    y1: 8,
    x2: 15,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E82C3D",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2F986"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2369_2233",
    x1: 12,
    y1: 7.5,
    x2: 12,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionGiftColoredRed);
export default __webpack_public_path__ + "static/media/ic_action_gift_colored_red.77e557848347752d4da72518e05bf719.svg";
export { ForwardRef as ReactComponent };